import { useQuery, NetworkStatus } from '@apollo/client';
import { get } from 'lodash';
import GET_RECENT_TEMPLATES from '../gql/getRecentTemplates.graphql';
import { RECENT_TEMPLATES_COUNT } from './constants';

const useGetRecentTemplates = () => {
  const { data, loading, error, networkStatus } = useQuery(
    GET_RECENT_TEMPLATES,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        first: RECENT_TEMPLATES_COUNT,
      },
    },
  );

  return {
    data: get(data, 'viewer.recentlyUsedTaskListTemplates.nodes', []),
    error,
    loading,
    refetching: networkStatus === NetworkStatus.refetch,
  };
};

export default useGetRecentTemplates;
